import "./site-overrides.css";
import "./enrollment-flow.css";
import "./growth-enhancements.css";
import "./website-config.js";
import "./site-overrides.js";
import "./enrollment-flow.js";
import "./growth-enhancements.js";
import "./production-overrides.js";
import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import FreeTrial from "@/pages/FreeTrial";
import Contact from "@/pages/Contact";
import LegalPolicy from "@/pages/LegalPolicy";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminStudentDetail from "@/pages/admin/AdminStudentDetail";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminClasses from "@/pages/admin/AdminClasses";
import AdminTeachers from "@/pages/admin/AdminTeachers";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSettings from "@/pages/admin/AdminSettings";


const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};


const AppShell = () => {
    const { pathname } = useLocation();
    if (pathname.startsWith("/admin")) {
        return (
            <Routes>
                <Route path="/admin" element={<AdminLogin />} />
                <Route element={<AdminLayout />}>
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/admin/students" element={<AdminStudents />} />
                    <Route path="/admin/students/:id" element={<AdminStudentDetail />} />
                    <Route path="/admin/enquiries" element={<AdminEnquiries />} />
                    <Route path="/admin/payments" element={<AdminPayments />} />
                    <Route path="/admin/classes" element={<AdminClasses />} />
                    <Route path="/admin/teachers" element={<AdminTeachers />} />
                    <Route path="/admin/reports" element={<AdminReports />} />
                    <Route path="/admin/settings" element={<AdminSettings />} />
                </Route>
            </Routes>
        );
    }
    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/free-trial" element={<FreeTrial />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<LegalPolicy />} />
                <Route path="/privacy" element={<LegalPolicy />} />
                <Route path="/refund-policy" element={<LegalPolicy />} />
                <Route path="/cancellation-policy" element={<LegalPolicy />} />
            </Routes>
            <Footer />
            <WhatsAppButton />
        </>
    );
};


function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);


    return (
        <div className="App min-h-screen bg-cream text-ink">
            <div className="noise-overlay" aria-hidden />
            <BrowserRouter>
                <ScrollManager />
                <AppShell />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}


export default App;

